export default class Contactbox {
    constructor() {
        this.form();
    }

    form() {
        // set "notEmpty" class on startup and on blur
        const fields = document.querySelectorAll('.-js-field');

        [].forEach.call(fields, field => {
            setClasses(field);
            field.addEventListener('blur', () => {
                setClasses(field);
            })
        });

        function setClasses(field) {
            if (field.value) {
                field.classList.add('-js-field--not-empty');
            } else {
                field.classList.remove('-js-field--not-empty');
            }
        }
    }
}
